const TENANT_CONFIG = {
  da: {
    department: { name: "DA", code: "DA" },
    citySuffix: "Development Authority",
  },
  avp: {
    department: { name: "AVP", code: "AVP" },
    citySuffix: "",
  },
  up: {
    department: { name: "UP", code: "UP" },
    citySuffix: "",
  },
};

const resolveDepartmentAndCity = ({ tenantId, userDetails, isSuperUser }) => {
  if (isSuperUser || !tenantId || !userDetails?.location1) {
    return { department: null, city: null };
  }

  const tenantKey = Object.keys(TENANT_CONFIG).find((key) =>
    tenantId.toLowerCase().includes(key)
  );

  if (!tenantKey) {
    return { department: null, city: null };
  }

  const config = TENANT_CONFIG[tenantKey];
  const location = userDetails.location1;

  return {
    department: config.department,
    city: {
      name: config.citySuffix
        ? `${location} ${config.citySuffix}`
        : location,
      code: location,
    },
  };
};

export default resolveDepartmentAndCity